import { render, staticRenderFns } from "./CrossReference.vue?vue&type=template&id=46b8ab4f"
import script from "./CrossReference.vue?vue&type=script&lang=js"
export * from "./CrossReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports